import { render, staticRenderFns } from "./AnnouncementMenu.vue?vue&type=template&id=3cf2acde&scoped=true&"
import script from "./AnnouncementMenu.vue?vue&type=script&lang=js&"
export * from "./AnnouncementMenu.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementMenu.vue?vue&type=style&index=0&id=3cf2acde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2acde",
  null
  
)

export default component.exports